export default __webpack_public_path__ + "static/media/QF_logo.d13f8fce.png";